
import React from "react";

const alliances = [
    {
        name: "Chaos Quotient",
        place: "1st",
        days: 21,
        date: "July 2, 2022",
        playerCount: "9",
        points: "3,023,772",
        cities: "403",
        faith: "43",
        ts: "49,071,447",
        players: [
            ["FaceTrolled3938", "Second Leader", "3", "803,062", "120,798,192"],
            ["vindu0050", "Second Leader", "4", "795,722", "186,639,828"],
            ["CoolAIscle0753", "Leader", "6", "433,002", "285,774,735"],
            ["juanita💜9449", "Member", "7", "345,581", "73,526,300"],
            ["Popov4738", "Member", "8", "327,080", "263,207,610"],
            ["MonkeySuit0679", "Officer", "12", "208,804", "14,850,377"],
            ["phelony6973", "Member", "17", "53,794", "0"],
            ["Innuendo0198", "Member", "18", "53,041", "0"],
            ["ItsKraZyKev8434", "Member", "21", "3,588", "0"],
        ],
    },
    {
        name: "Phoenix",
        place: "2nd",
        days: 21,
        date: "July 2, 2022",
        playerCount: "12",
        points: "3,976,427",
        cities: "564",
        faith: "16",
        ts: "50,305,576",
        players: [
            ["Diefaster9156", "Second Leader", "1", "1,237,361", "6,800,000"],
            ["Avatar3670", "Second Leader", "2", "961,610", "201,653,000"],
            ["TingWing3706", "Second Leader", "5", "558,079", "48,000,000"],
            ["StoneRemnant6021", "Member", "9", "316,353", "12,365,368"],
            ["Workaholic6225", "Second Leader", "10", "309,957", "1,185,372"],
            ["Th3B3arJ3w/Djofull3065", "Member", "13", "181,329", "0"],
            ["Treefires3783", "Member", "14", "179,045", "20,555,635"],
            ["OhDave6676", "Leader", "15", "123,213", "1,517,001"],
            ["F95395", "Member", "16", "94,764", "0"],
            ["SofaQueen6034", "Member", "19", "7,373", "0"],
            ["8887490", "Member", "20", "7,200", "0"],
            ["eriks2687", "Member", "23", "51", "0"],
        ],
    },
];

const SummaryTable = ({ alliance }) => (
    <div className="champions-summary">
        <table>
            <thead>
                <tr>
                    <th>Conquerors</th>
                    <th>World</th>
                    <th>Place</th>
                    <th>Days</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{alliance.name}</td>
                    <td>Alpha W0.1</td>
                    <td>{alliance.place}</td>
                    <td>{alliance.days}</td>
                    <td>{alliance.date}</td>
                </tr>
            </tbody>
        </table>

        <table>
            <thead>
                <tr>
                    <th>Player Count</th>
                    <th>Points</th>
                    <th>Cities</th>
                    <th>Faith</th>
                    <th>TS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{alliance.playerCount}</td>
                    <td>{alliance.points}</td>
                    <td>{alliance.cities}</td>
                    <td>{alliance.faith}</td>
                    <td>{alliance.ts}</td>
                </tr>
            </tbody>
        </table>
    </div>
);

const PlayerTable = ({ alliance }) => (
    <div className="champions-player-table">
        <table>
            <thead>
                <tr>
                    <th>Player</th>
                    <th>Alliance Title</th>
                    <th>Rank</th>
                    <th>Score</th>
                    <th>Donations</th>
                </tr>
            </thead>
            <tbody>
                {alliance.players.map((player) => (
                    <tr key={player[0]}>
                        {player.map((value, index) => (
                            <td key={index}>{value}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

const Champions = () => {
    return (
        <main className="champions-page">
            <header className="champions-header">
                <p className="champions-eyebrow">CONQUEST &amp; VIRTUE</p>
                <h1>Wall of Champions</h1>
                <p className="champions-intro">
                    Celebrating the alliances and players who have shaped
                    the history of Conquest &amp; Virtue.
                </p>
            </header>

            <section className="champions-archive">
                <div className="archive-heading">
                    <span className="archive-status">HISTORICAL RESULTS</span>
                    <h2>Alpha World 0.1</h2>
                    <p>Winner, Server Conclusion, and World Results</p>
                </div>

                <div className="champions-announcement">
                    <h3>Greetings and Salutations, Conquerors and the Virtuous!</h3>

                    <p>
                        <strong>
                            Thank you for your commitment and diligence
                            in testing Alpha World 0.
                        </strong>{" "}
                        Your efforts helped identify and resolve critical
                        issues, along with many other bugs and suggestions.
                        Finding and fixing these issues early in development
                        was invaluable.
                    </p>

                    <h3>Alpha World 0 Conclusion</h3>
                    <p>
                        An unexpected underflow bug caused negative troop
                        numbers to round up, producing phantom troops.
                        Players on both sides documented and reported the
                        issue, allowing it to be repaired so the server
                        could continue.
                    </p>

                    <h3>Alpha World 0.1 Results</h3>
                    <p>
                        Congratulations to <strong>Chaos Quotient</strong>,
                        which had the most faith at the conclusion of the
                        server. Players were awarded a Gold Crown for
                        Alpha World 0.
                    </p>
                </div>

                <div className="champions-alliance-grid">
                    {alliances.map((alliance) => (
                        <article
                            className={`champions-alliance ${
                                alliance.place === "1st" ? "champion-winner" : ""
                            }`}
                            key={alliance.name}
                        >
                            <div className="alliance-heading">
                                <span className="alliance-place">
                                    {alliance.place} Place
                                </span>
                                <h3>{alliance.name}</h3>
                                {alliance.place === "1st" && (
                                    <p className="winner-label">
                                        Alpha World 0.1 Champion
                                    </p>
                                )}
                            </div>

                            <SummaryTable alliance={alliance} />
                            <h4>Player Standings</h4>
                            <PlayerTable alliance={alliance} />
                        </article>
                    ))}
                </div>

                <p className="champions-source-note">
                    Archived Alpha World 0.1 results. Historical player
                    names and statistics are presented as recorded.
                </p>
            </section>

            <section className="champions-future">
                <h2>The Next World Awaits</h2>
                <p>
                    New testing rounds will bring new rivalries, alliances,
                    and champions. Historical results will remain here as
                    the Wall of Champions grows.
                </p>
            </section>
        </main>
    );
};

export default Champions;
